import { render, staticRenderFns } from "./ReportConfig.vue?vue&type=template&id=733d5066&scoped=true"
import script from "./ReportConfig.vue?vue&type=script&lang=js"
export * from "./ReportConfig.vue?vue&type=script&lang=js"
import style0 from "./ReportConfig.vue?vue&type=style&index=0&id=733d5066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733d5066",
  null
  
)

export default component.exports